import { MembersActionTypes, SignalRTypes } from "./actionTypes";
import { Cookies } from "../../helpers";

export function openMobileTableDetails(open) {
  return {
    type: MembersActionTypes.Open_Mobile_Table_Details,
    open,
  };
}

export function openBetDetailsModal(open) {
  return {
    type: MembersActionTypes.Open_Bet_Details_Modal,
    open,
  };
}
export function openRewardSpinModal(open) {
  return {
    type: MembersActionTypes.Open_Reward_Spin_Modal,
    open,
  };
}

export function openVoucherModal(open) {
  return {
    type: MembersActionTypes.Open_Voucher_Modal,
    open,
  };
}

export function openMobileVoucherDetails(open) {
  return {
    type: MembersActionTypes.Open_Mobile_Voucher_Details,
    open,
  };
}

export function partGroups() {
  return {
    type: SignalRTypes.Handle_Join_Part_Groups,
    isPartOnly: true,
  };
}

export function setSelectedCurrency(currency) {
  return {
    type: MembersActionTypes.Set_Selected_Currency,
    currency,
  };
}
export function addMemberPhone() {
  return {
    type: MembersActionTypes.Add_Second_Member_Phone_Request,
  };
}

export function sendAddValidatePhone(data) {
  return {
    type: MembersActionTypes.Validate_Add_Second_Phone_Request,
    data,
  };
}

export function updateMemberDetails(data) {
  return {
    type: MembersActionTypes.Member_Details_Request,
    data,
  };
}

export function getMemberDetails(data) {
  return {
    type: MembersActionTypes.Get_Member_Details_Request,
    data,
  };
}

export function sendVerifyEmail(data) {
  return {
    type: MembersActionTypes.Send_Verify_Email_Request,
    data,
  };
}

export function AddMemberProviders(data) {
  return {
    type: MembersActionTypes.Add_Member_Providers_Request,
    data,
  };
}
export function CreateVirtualSportToken(data) {
  return {
    type: MembersActionTypes.Create_Virtual_Sport_Token_Request,
    data,
  };
}
export function GetVirtualsSportMenu(data) {
  return {
    type: MembersActionTypes.Get_Virtuals_Sport_Menu_Request,
    data,
  };
}

export function setVirtualSportIframeUrl(url) {
  return {
    type: MembersActionTypes.Set_Virtual_Sport_Iframe_Url,
    url,
  };
}

export function resetVirtualSportIframeUrl() {
  return {
    type: MembersActionTypes.Reset_Virtual_Sport_Iframe_Url,
  };
}
export function getRewards() {
  return {
    type: MembersActionTypes.Get_Rewards_Request,
  };
}
export function getRewardsTransaction(data) {
  return {
    type: MembersActionTypes.Get_Rewards_Transaction_Request,
    data,
  };
}
export function clubRewardStatus(data) {
  return {
    type: MembersActionTypes.Get_Club_Reward_Status_Request,
    data,
  };
}
export function clubMemberRewardInfo(data) {
  return {
    type: MembersActionTypes.Get_Club_Member_Reward_Info_Request,
    data,
  };
}
export function resetSingleReward() {
  return {
    type: MembersActionTypes.Reset_Single_Reward,
  };
}
export function customerClubRewardRedeem(data) {
  return {
    type: MembersActionTypes.Customer_Club_Reward_Redeem_Request,
    data,
  };
}
export function getWheelOfFortuneGift(data) {
  return {
    type: MembersActionTypes.Get_Wheel_Of_Fortune_Gift_Request,
    data,
  };
}
export function wheelOfFortuneSpin(data) {
  return {
    type: MembersActionTypes.Wheel_Of_Fortune_Spin_Request,
    data,
  };
}

export function mtnDeposit(data) {
  return {
    type: MembersActionTypes.Mtn_Deposit_Request,
    data,
  };
}
export function orangeDeposit(data) {
  return {
    type: MembersActionTypes.Orange_Deposit_Request,
    data,
  };
}

export function mtnWithdraw(data) {
  return {
    type: MembersActionTypes.Mtn_Withdraw_Request,
    data,
  };
}
export function tipMeWithdraw(data) {
  return {
    type: MembersActionTypes.Tipme_Withdraw_Request,
    data,
  };
}
export function tipMeConfirmWithdraw(data) {
  return {
    type: MembersActionTypes.Tipme_Confirm_Withdraw_Request,
    data,
  };
}
export function orangeWithdraw(data) {
  return {
    type: MembersActionTypes.Orange_Withdraw_Request,
    data,
  };
}

export function depositFromVoucher(voucher) {
  if (voucher.length === 0) {
    return {
      type: MembersActionTypes.Deposit_From_Voucher_Error,
      message: "Please Enter Voucher",
    };
  }

  if (voucher.length !== 16) {
    return {
      type: MembersActionTypes.Deposit_From_Voucher_Error,
      message: "Voucher Must Be 16 characters",
    };
  }

  return {
    type: MembersActionTypes.Deposit_From_Voucher_Request,
    voucher,
  };
}

export function withdrawalToVoucher(data) {
  const selectedCurrency = Cookies.get("selectedCurrency");
  let amount = data && data.amount;
  if (!amount || amount === "0") {
    return {
      type: MembersActionTypes.Withdrawal_To_Voucher_Error,
      message: "Please enter Amount",
    };
  }

  let amountCheck = amount % 5 === 0;
  if (!amountCheck && selectedCurrency.currencyId === 1) {
    return {
      type: MembersActionTypes.Withdrawal_To_Voucher_Error,
      message: "Amount must divide by 5",
    };
  }

  if (amount > selectedCurrency.balance) {
    return {
      type: MembersActionTypes.Withdrawal_To_Voucher_Error,
      message: "Amount is bigger then your balance",
    };
  }

  return {
    type: MembersActionTypes.Withdrawal_To_Voucher_Request,
    data,
  };
}

export function memberTransactions(data) {
  return {
    type: MembersActionTypes.Member_Transactions_Request,
    data,
  };
}

export function memberForms(data) {
  return {
    type: MembersActionTypes.Member_Forms_Request,
    data,
  };
}

export function formsDetails(data) {
  return {
    type: MembersActionTypes.Forms_Details_Request,
    data,
  };
}

export function addProviderList() {
  return {
    type: MembersActionTypes.Add_Provider_List_Request,
  };
}
export function MemberaddProviderList() {
  return {
    type: MembersActionTypes.Member_Add_Provider_List_Request,
  };
}
export function TipMeCustomerSearch(data) {
  return {
    type: MembersActionTypes.Tip_Me_Customer_Search_Request,
    data,
  };
}
export function DepositeTipMeVerification(data) {
  return {
    type: MembersActionTypes.Deposite_Tip_Me_Customer_Search_Request,
    data,
  };
}
export function firstDepositeFirstStepMessage(data) {
  return {
    type: MembersActionTypes.Tip_Me_First_Deposit_Message_Request,
    data,
  };
}
export function tipMeOTPVertificaton(data, methodName) {
  return {
    type: MembersActionTypes.Tip_Me_OTP_Verification_Request,
    data,
    methodName,
  };
}

export function getVoucherDetails(data) {
  return {
    type: MembersActionTypes.Voucher_Details_Request,
    data,
  };
}

export function skip() {
  return {
    type: MembersActionTypes.Skip,
  };
}

export function init() {
  return {
    type: MembersActionTypes.Init,
  };
}

export function setMemberApprovedJackpotWinnings(jackpotId) {
  return {
    type: MembersActionTypes.Member_Approved_Jackpot_Winnings_Request,
    jackpotId,
  };
}

export function checkDepositBonusConditions() {
  return {
    type: MembersActionTypes.CheckDepositBonusConditions_Request,
  };
}

export function createCustomerServiceCode() {
  return {
    type: MembersActionTypes.CreateCustomerServiceCode_Request,
  };
}
export function getSignedInLoyalityRewards() {
  return {
    type: MembersActionTypes.Get_Sign_In_Loyalty_Rewards_Options_Request,
  };
}
export function GetLoyaltyRewardsCoupons(data) {
  return {
    type: MembersActionTypes.Get_Loyalty_Rewards_Coupons_Request,
    data,
  };
}
export function createMemberSlotsBonus(data) {
  return {
    type: MembersActionTypes.Create_Member_Slots_Bonus_Request,
    data,
  };
}

export function GetLastRewardNotifications() {
  return {
    type: MembersActionTypes.Get_Last_Reward_Notifications_Request,
  };
}
export function GetNotificationHistory(data) {
  return {
    type: MembersActionTypes.Get_Notification_History_Request,
    data,
  };
}
export function DeleteNotification(data) {
  return {
    type: MembersActionTypes.Delete_Notification_Request,
    data,
  };
}
export function GetNotificationCount() {
  return {
    type: MembersActionTypes.Get_Notification_Count_Request,
  };
}
export function MuteNotification(data) {
  return {
    type: MembersActionTypes.Mute_Notification_Request,
    data,
  };
}

export function getFormCashOutOffer(data) {
  let amountCheck = data.cashoutAmount % 5 === 0;
  if (!amountCheck) {
    console.log("amountcheck", amountCheck);
    return {
      type: MembersActionTypes.Get_Form_Cash_Out_Offer_Error,
      cashOutOfferError: "Amount must divide by 5",
    };
  }
  return {
    type: MembersActionTypes.Get_Form_Cash_Out_Offer_Request,
    data,
  };
}

export function earlyCashOut(data) {
  return {
    type: MembersActionTypes.Early_Cash_Out_Request,
    data,
  };
}

export function setMemberCashOutOffer(data) {
  return {
    type: MembersActionTypes.Set_Member_Cash_Out_Offer,
    data,
  };
}

export function resetMemberCashOutOffer(data) {
  return {
    type: MembersActionTypes.Reset_Member_Cash_Out_Offer,
    data,
  };
}

export function NotificationDetails(data) {
  return {
    type: MembersActionTypes.Get_Notification_Details_Request,
    data,
  };
}
export function ReadNotificationStatus(data) {
  return {
    type: MembersActionTypes.Read_Notification_Status_Request,
    data,
  };
}
export function ManageMemeberFavorite(data) {
  return {
    type: MembersActionTypes.Manage_Memeber_Favorite_Request,
    data,
  };
}
export function CreateMemberSlotsBonusByCouponCode(data) {
  return {
    type: MembersActionTypes.Create_Member_Slots_Bonus_By_Coupon_Code_Request,
    data,
  };
}

export function getMembersGames(templateId) {
  return {
    type: MembersActionTypes.Get_Members_Games_Request,
    templateId,
  };
}

export function getMemberBalance() {
  return {
    type: MembersActionTypes.Get_Member_Balance_Request,
  };
}
